import { useMutation } from '@tanstack/react-query';
import * as qs from 'qs';

import { apiClient } from '@services/apiClient';

interface IParams {
  fftChartType?: number;
  readingId?: number;
  isImpactVue?: boolean;
}

const chartFftExportFn = (params: IParams) =>
  apiClient.get(`${APP_API_URL_V2}fsd/charts-fft${params.isImpactVue ? '/impact-vue' : ''}/csv`, {
    params,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params),
    },
  });

export const useChartFftExportMutation = () => {
  return useMutation({
    mutationFn: chartFftExportFn,
  });
};
